import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-warning-resetting-to-draft',
  templateUrl: './warning-resetting-to-draft.component.html',
  styleUrls: ['./warning-resetting-to-draft.component.scss'],
  standalone: false,
})
export class WarningResettingToDraftComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
  }

}
